import './units/index';
export { add, subtract } from './moment/add-subtract';
export { getMonth } from './utils/date-getters';
export { parseDate } from './create/local';
export { formatDate } from './format';
export { defineLocale, getSetGlobalLocale, listLocales } from './locale/locales';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/~/ngx-bootstrap/chronos/index.js
// module id = ../../../../ngx-bootstrap/chronos/index.js
// module chunks = 8